import React from 'react';
import AdminDashboardChart from './AdminDashboardChart';
import InvitationStatusChart from './InvitationStatusChart';
import UserRegistrationChart from './UserRegistrationChart';
import HealthStatusWidget from '../admin/HealthStatusWidget';

const AdminDashboard = () => {
  return (
    <div className="mt-8">
      <h2 className="text-2xl font-bold mb-6 text-[#054581]">Analytics Dashboard</h2>
      <div className="space-y-6">
        <div className="bg-white rounded-lg p-6 border border-[#1086a4] shadow-sm">
          <HealthStatusWidget />
        </div>
        <div className="bg-white rounded-lg p-6 border border-[#1086a4] shadow-sm">
          <UserRegistrationChart />
        </div>
        <div className="bg-white rounded-lg p-6 border border-[#1086a4] shadow-sm">
          <AdminDashboardChart />
        </div>
        <div className="bg-white rounded-lg p-6 border border-[#1086a4] shadow-sm">
          <InvitationStatusChart />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
